export const DEFAULT_NODE_COLOR = '#ff4d4d'

export const DEFAULT_COLOR_PALETTE = [
  '#1d3557',
  '#f37021',
  '#ff4d4d',
  '#ffd166',
  '#06d6a0',
  '#118ab2',
  '#7b61ff',
  '#ef476f',
  '#4cc9f0',
  '#b8f35a',
  '#ff8fab',
  '#c77dff',
]

const HEX_COLOR_RE = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i

export function normalizeHexColor(color, fallback = null) {
  const raw = `${color || ''}`.trim()
  const match = raw.match(HEX_COLOR_RE)
  if (match) {
    const hex = match[1].toLowerCase()
    if (hex.length === 3) {
      return `#${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
    }
    return `#${hex}`
  }

  const fallbackRaw = `${fallback || ''}`.trim()
  const fallbackMatch = fallbackRaw.match(HEX_COLOR_RE)
  if (!fallbackMatch) return null

  const fallbackHex = fallbackMatch[1].toLowerCase()
  if (fallbackHex.length === 3) {
    return `#${fallbackHex[0]}${fallbackHex[0]}${fallbackHex[1]}${fallbackHex[1]}${fallbackHex[2]}${fallbackHex[2]}`
  }
  return `#${fallbackHex}`
}

export function isHexColor(color) {
  return !!normalizeHexColor(color)
}

export function hexToRgb(color) {
  const hex = normalizeHexColor(color)
  if (!hex) return null
  return {
    r: Number.parseInt(hex.slice(1, 3), 16),
    g: Number.parseInt(hex.slice(3, 5), 16),
    b: Number.parseInt(hex.slice(5, 7), 16),
  }
}

export function rgbToHex({ r, g, b } = {}) {
  const channel = (value) => {
    const n = Math.max(0, Math.min(255, Math.round(Number(value) || 0)))
    return n.toString(16).padStart(2, '0')
  }
  return `#${channel(r)}${channel(g)}${channel(b)}`
}

export function mixHexColors(colorA, colorB, amount = 0.5, fallback = '#ffffff') {
  const a = hexToRgb(colorA) || hexToRgb(fallback)
  const b = hexToRgb(colorB) || hexToRgb(fallback)
  if (!a || !b) return normalizeHexColor(fallback, '#ffffff')
  const t = Math.max(0, Math.min(1, Number(amount) || 0))
  return rgbToHex({
    r: a.r + (b.r - a.r) * t,
    g: a.g + (b.g - a.g) * t,
    b: a.b + (b.b - a.b) * t,
  })
}

export function shadeHexColor(color, value = 0, fallback = '#ffffff') {
  const base = normalizeHexColor(color, fallback) || '#ffffff'
  const n = Math.max(-1, Math.min(1, Number(value) || 0))
  if (n > 0) return mixHexColors(base, '#ffffff', n, fallback)
  if (n < 0) return mixHexColors(base, '#000000', Math.abs(n), fallback)
  return base
}
